import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  scrollType: 0,
  navName: sessionStorage.getItem("navName")||'首页',
  isDarkMode: sessionStorage.getItem("isDarkMode") === "true"
};

const mutations = {
  setScrollType: (state, info) => {
    state.scrollType = info;
  },
  setNavName: (state, info) => {
    state.navName = info;
    sessionStorage.setItem("navName", info);
  },
  toggleDarkMode: (state) => {
    state.isDarkMode = !state.isDarkMode;
    sessionStorage.setItem("isDarkMode", state.isDarkMode);
  },
  setDarkMode: (state, value) => {
    state.isDarkMode = value;
    sessionStorage.setItem("isDarkMode", value);
  }
};

export default new Vuex.Store({
  state,
  mutations,
});


// WEBPACK FOOTER //
// ./src/store/index.js